import { render } from "./ConsultaPorChaveComponent.vue?vue&type=template&id=69388638&scoped=true"
import script from "./ConsultaPorChaveComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaPorChaveComponent.vue?vue&type=script&lang=js"

import "./ConsultaPorChaveComponent.vue?vue&type=style&index=0&id=69388638&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69388638"]])

export default __exports__